/**************************************************
 * Nombre:       Formulario_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CategoryOutlined,  UpgradeOutlined} from "@mui/icons-material";

const Formulario_Categorias = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={CategoryOutlined} nombre={'Nombre Categoria'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={UpgradeOutlined} nombre={'Prioridad'} dato={'prioridad'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Categorias